import { Wordmark } from "@/components/brand/Wordmark";

export const PageHero = ({ eyebrow, title, children, testId = "page-hero" }) => (
  <section className="mx-auto max-w-7xl px-4 pb-10 pt-12 sm:px-8 sm:pt-16" data-testid={testId}>
    <Wordmark size="page" testId="page-wordmark" className="fade-up" />
    <div className="gold-line mt-6 max-w-md" />
    {eyebrow && (
      <p className="mt-6 font-display text-[0.7rem] uppercase tracking-[0.3em] text-[var(--red-bright)]">{eyebrow}</p>
    )}
    {title && (
      <h1 className="mt-2 font-display text-base font-bold uppercase tracking-wider text-neutral-100 md:text-lg" data-testid="page-title">
        {title}
      </h1>
    )}
    {children}
  </section>
);
